import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import useTranslate from '../../../lib/hooks/use-translate'
import { HostFamilyInput } from '../../../lib/types/models/host-family/host-family-input'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledPhoneInput from '../../elements/inputs/controlled-phone-input'

const HostFamilyLocalRepresentativeForm = () => {
  const { t } = useTranslate()
  const form = useFormContext<HostFamilyInput>()

  return (
    <InnerBox className="flex flex-col gap-4 rounded-xl">
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        {t('host.family.local.representative.title')}
      </Typography>
      <div className="flex gap-3">
        <FormField
          control={form.control}
          name="localRepresentativeLastName"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput
                  {...field}
                  type="text"
                  label={t('oto.individual.placements.transfer.person.last.name')}
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="localRepresentativeFirstName"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput
                  {...field}
                  type="text"
                  label={t('oto.individual.placements.transfer.person.first.name')}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
      <div className="flex gap-3">
        <FormField
          control={form.control}
          name="localRepresentativePhone"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledPhoneInput
                  {...field}
                  label={t('oto.individual.placements.transfer.person.phone.number')}
                  defaultCountry="FR"
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="localRepresentativeEmail"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput
                  {...field}
                  type="email"
                  label={t('oto.individual.placements.transfer.person.email')}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </InnerBox>
  )
}

export default HostFamilyLocalRepresentativeForm
